import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DeleteObjectModal({
  confirmLabel,
  message,
  onConfirm,
  onReject,
  rejectLabel,
  title
}) {
  return /*#__PURE__*/_jsxs(Modal, {
    use: "danger",
    onEsc: onReject,
    "data-selenium-test": 'delete-dialog',
    "data-test-id": "delete-dialog",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onReject,
        "data-test-id": "close-btn"
      }), /*#__PURE__*/_jsx(H2, {
        children: title
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: message
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        "data-selenium-test": "delete-dialog-confirm-button",
        "data-confirm-button": "accept",
        onClick: onConfirm,
        use: "danger",
        autoFocus: true,
        marginInlineStart: "0",
        children: confirmLabel
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onReject,
        use: "tertiary-light",
        "data-selenium-test": "delete-dialog-reject-button",
        children: rejectLabel
      })]
    })]
  });
}